const cleanFileName = (fileName: string) => {
	const [name, extension] = fileName.split('.').reduce(
		(acc, part, index, arr) => {
			if (index === arr.length - 1) {
				acc[1] = part;
			} else {
				acc[0] += (acc[0] ? '.' : '') + part;
			}
			return acc;
		},
		['', ''],
	);

	const cleanedName = name
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-zA-Z0-9\s]/g, '');

	return extension
		? `${cleanedName.toLowerCase()}.${extension.toLowerCase()}`
		: cleanedName.toLowerCase();
};

export {cleanFileName};
